import * as React from 'react';
import {  Col, Row } from "react-bootstrap";
import UnapprovedUserList from '../../components/admin/UnapprovedUserList';
import PaymentApproval from '../../components/admin/PaymentApproval';
import UnapprovedClaimableList from '../../components/admin/UnapprovedClaimableList';

export default function InitialTab() {
  const [soloClaimsHidden, setSoloClaimsHidden] = React.useState<boolean>(false);
  return (
    <Row>
      <Col lg>
        <UnapprovedUserList showBinnedUsers={false}/>
      </Col>
      <Col hidden={soloClaimsHidden} lg>
        <UnapprovedClaimableList field={"solo"} setHidden={setSoloClaimsHidden} />
      </Col>
      <Col lg className='d-none d-md-block'>
        <PaymentApproval />
      </Col>
    </Row>
  )
}
